export const TYPE_BILLING = 'B';
export const TYPE_SHIPPING = 'S';
